import { CALCULATIONS_TIME_AND_BALANCE } from './timeAndBalance';
import { CALCULATIONS_STEPS_TITLES } from './stepsTitles';
import { CALCULATIONS_CREATE_CALCULATION } from './createCalculation';
import { CALCULATION_STEP } from './calculationStep';
import { CALCULATIONS_INHERITED_BALANCE_ACCOUNTS } from './inheritedBalanceAccounts';
import { CALCULATIONS_CUSTOM_ELEMENTS } from './customElements';
import { CALCULATIONS_BALANCE_ACCOUNTS } from './balanceAccounts';
import { CALCULATIONS_SHARED } from './shared';
import { CALCULATION_STEP_DOCUMENTS } from './documents';
import { CALCULATION_COMMENTS } from './comments';
import { CALCULATION_STEP_WARNINGS } from './warnings';
export const CALCULATIONS_STEPS = {
    ...CALCULATIONS_TIME_AND_BALANCE,
    ...CALCULATIONS_STEPS_TITLES,
    ...CALCULATIONS_CREATE_CALCULATION,
    ...CALCULATION_STEP,
    ...CALCULATIONS_INHERITED_BALANCE_ACCOUNTS,
    ...CALCULATIONS_CUSTOM_ELEMENTS,
    ...CALCULATIONS_BALANCE_ACCOUNTS,
    ...CALCULATIONS_SHARED,
    ...CALCULATION_STEP_DOCUMENTS,
    ...CALCULATION_COMMENTS,
    ...CALCULATION_STEP_WARNINGS
};
